export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  about: 'nav-about',
  services: 'nav-services',
  portfolio: 'nav-portfolio',
  results: 'nav-results',
  eureka1: 'nav-eureka1',
  blog: 'nav-blog',
  contact: 'nav-contact',
  cta: 'nav-cta-book-call',
  mobileToggle: 'nav-mobile-toggle',
};

export const HOME = {
  hero: 'home-hero',
  heroCta: 'home-hero-cta-book-call',
  heroSecondary: 'home-hero-cta-services',
  whoIHelp: 'home-who-i-help',
  whatIHelpWith: 'home-what-i-help-with',
  whyHallie: 'home-why-hallie',
  featuredServices: 'home-featured-services',
  serviceCard: 'home-service-card',
  featuredResults: 'home-featured-results',
  testimonials: 'home-testimonials',
  ctaBand: 'home-cta-band',
  ctaBandButton: 'home-cta-band-book-call',
};

export const SERVICES = {
  page: 'services-page',
  card: 'services-card',
  detailHero: 'service-detail-hero',
  detailCta: 'service-detail-cta',
  faqItem: 'service-faq-item',
};

export const FORM = {
  contactForm: 'contact-form',
  contactName: 'contact-form-name',
  contactEmail: 'contact-form-email',
  contactBusiness: 'contact-form-business',
  contactBusinessType: 'contact-form-business-type',
  contactMessage: 'contact-form-message',
  contactSubmit: 'contact-form-submit',
  discoveryForm: 'discovery-call-form',
  discoveryName: 'discovery-call-name',
  discoveryEmail: 'discovery-call-email',
  discoveryBusiness: 'discovery-call-business',
  discoveryDate: 'discovery-call-date',
  discoveryChallenge: 'discovery-call-challenge',
  discoverySubmit: 'discovery-call-submit',
  newsletterEmail: 'newsletter-email',
  newsletterSubmit: 'newsletter-submit',
};

export const PORTFOLIO = {
  page: 'portfolio-page',
  card: 'portfolio-card',
  detail: 'portfolio-detail',
};

export const BLOG = {
  page: 'blog-page',
  card: 'blog-card',
  detail: 'blog-detail',
  categoryFilter: 'blog-category-filter',
};

export const FOOTER = {
  container: 'site-footer',
  newsletter: 'footer-newsletter',
};
